import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OrderProvider } from './contexts/OrderContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ActivityLogProvider } from './contexts/ActivityLogContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ToastProvider } from './components/ui/Toast';
import { Header } from './components/Header';
import { TopNav } from './components/TopNav';
import { Footer } from './components/Footer';
import { LoginPage } from './pages/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { OrdersDashboard } from './pages/OrdersDashboard';
import { LabelControl } from './pages/LabelControl';
import { ProductionView } from './pages/ProductionView';
import { MenuView } from './pages/MenuView';
import { CompanySettings } from './pages/CompanySettings';
import { EmployeeList } from './pages/EmployeeList';
import { EmployeeOrderPage } from './pages/EmployeeOrderPage';
import { MyOrdersPage } from './pages/MyOrdersPage';
import { EmployeeProfilePage } from './pages/EmployeeProfilePage';
import { SettingsPage } from './pages/SettingsPage';
import { ReportsPage } from './pages/ReportsPage';
import { ActivityLogPage } from './pages/ActivityLogPage';
import { ClaimsPage } from './pages/ClaimsPage';
import { PromotionsPage } from './pages/PromotionsPage';
function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen bg-gray-50 font-sans text-gray-900 transition-colors" data-id="element-0">
      <Header data-id="element-1" />
      <TopNav data-id="element-2" />
      <main className="flex-1 overflow-x-hidden" data-id="element-3">{children}</main>
      <Footer data-id="element-4" />
    </div>;
}
export function App() {
  return <ThemeProvider data-id="element-5">
      <ToastProvider data-id="element-6">
        <AuthProvider data-id="element-7">
          <OrderProvider data-id="element-8">
            <NotificationProvider data-id="element-9">
              <ActivityLogProvider data-id="element-10">
                <Router data-id="element-11">
                  <Routes data-id="element-12">
                    <Route path="/login" element={<LoginPage data-id="element-14" />} data-id="element-13" />

                    {/* Admin Routes */}
                    <Route path="/admin/*" element={<ProtectedRoute allowedRoles={['admin']} data-id="element-16">
                          <Layout data-id="element-17">
                            <Routes data-id="element-18">
                              <Route path="orders" element={<OrdersDashboard data-id="element-20" />} data-id="element-19" />
                              <Route path="production" element={<ProductionView data-id="element-22" />} data-id="element-21" />
                              <Route path="labels" element={<LabelControl data-id="element-24" />} data-id="element-23" />
                              <Route path="companies" element={<CompanySettings data-id="element-26" />} data-id="element-25" />
                              <Route path="employees" element={<EmployeeList data-id="element-28" />} data-id="element-27" />
                              <Route path="menu" element={<MenuView data-id="element-30" />} data-id="element-29" />
                              <Route path="promotions" element={<PromotionsPage data-id="element-32" />} data-id="element-31" />
                              <Route path="reports" element={<ReportsPage data-id="element-34" />} data-id="element-33" />
                              <Route path="claims" element={<ClaimsPage data-id="element-36" />} data-id="element-35" />
                              <Route path="activity-log" element={<ActivityLogPage data-id="element-38" />} data-id="element-37" />
                              <Route path="settings" element={<SettingsPage data-id="element-40" />} data-id="element-39" />
                              <Route path="*" element={<Navigate to="orders" replace data-id="element-42" />} data-id="element-41" />
                            </Routes>
                          </Layout>
                        </ProtectedRoute>} data-id="element-15" />

                    {/* Employee Routes */}
                    <Route path="/employee/*" element={<ProtectedRoute allowedRoles={['employee']} data-id="element-44">
                          <Layout data-id="element-45">
                            <Routes data-id="element-46">
                              <Route path="order" element={<EmployeeOrderPage data-id="element-48" />} data-id="element-47" />
                              <Route path="my-orders" element={<MyOrdersPage data-id="element-50" />} data-id="element-49" />
                              <Route path="profile" element={<EmployeeProfilePage data-id="element-52" />} data-id="element-51" />
                              <Route path="*" element={<Navigate to="order" replace data-id="element-54" />} data-id="element-53" />
                            </Routes>
                          </Layout>
                        </ProtectedRoute>} data-id="element-43" />

                    <Route path="*" element={<Navigate to="/login" replace data-id="element-56" />} data-id="element-55" />
                  </Routes>
                </Router>
              </ActivityLogProvider>
            </NotificationProvider>
          </OrderProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>;
}